<template>
    <div class="questions-answers__item-text" v-html="answerText">
    </div>
</template>

<script>
    import Vue from 'vue';
	import {TOGGLE_LOADER} from "@/storage/mutations";
	import QuestionsAnswers from "./questions-answers.vue";

    export default{
	    components: {QuestionsAnswers},
	    name: 'Answer',
        props: ['answerName', 'answerText'],
	    beforeRouteUpdate (to, from, next) {
		    this.$store.commit(TOGGLE_LOADER, {state: false});
		    next();
	    },
        /*render (h) {
	    	return h(this.answerText)
        }*/
    }
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.questions-answers {
    &__item-title {
        color: $gray-dim-dark;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 14px;
        line-height: 23px;
    }
}
</style>